<template>
  <div class="page-content">
    <div class="content">
      <table-content :columns='columns' :tableData="tableData" :editIsNeed='false' :deleteIsNeed='false'>
        <template #from>
          <el-form :inline="true" :model="filters" :size="size" @keyup.enter.native="handleQuery" @submit.native.prevent>
            <el-form-item>
              <el-select v-model="filters.companyid" placeholder="请选择客户" filterable clearable >
                <el-option v-for="item in clientCompany" :key="item.value" :label="item.name" :value="item.id" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-model="filters.number" placeholder="合同编号" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="filters.time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy/MM/dd"
                clearable
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-select v-model="filters.status" placeholder="请选择合同状态" >
                <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value" ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item>
              <el-checkbox v-model="projectIsNeed">{{projectIsNeed?'隐藏':'展示'}}关联项目</el-checkbox>
            </el-form-item> -->
            <el-form-item>
              <el-button :size="size" type="primary" @click="handleQuery">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button :size="size" type="primary" @click="handleAdd">新增</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template #option='scope'>
          <el-button @click.native.prevent="handleDetail(scope.scope)" type="text" :size="size" >详情</el-button>
        </template>
      </table-content>
    </div>
    <!-- 新增编辑 -->
    <add-or-update ref="addOrUpdate" v-if="addOrUpdateVisible" :allCompany='allCompany' @handleQuery='handleQuery' ></add-or-update>
    <!-- 详情 -->
    <detail-drawer ref="detailDrawer" v-if="detailDrawerVisible" :status='status' :taskList='taskList' :cycleList='cycleList'></detail-drawer>
  </div>
</template>

<script>
import detailDrawer from './detailDrawer.vue'
import tableContent from './tableContent.vue'
import addOrUpdate from './addOrUpdate.vue'
export default {
  components: {
    tableContent,
    detailDrawer,
    addOrUpdate
  },
  data () {
    return {
      projectIsNeed: false,
      addOrUpdateVisible: false,
      detailDrawerVisible: false,
      size: 'small',
      clientCompany: [],
      allCompany: [],
      measureList: [],
      filters: {
        companyid: '',
        time: [],
        status: -1,
        number: ""
      },
      columns: [
        { prop: 'name', label: '合同名称', minWidth: 200 },
        { prop: 'number', label: '合同编号', minWidth: 160 },
        { prop: 'serviceProviderCompanyName', label: '服务提供方公司', minWidth: 200 },
        { prop: 'serviceProviderTransactorNickname', label: '服务提供方公司办理人', minWidth: 200 },
        { prop: 'clientCompanyName', label: '客户公司', minWidth: 200 },
        { prop: 'clientTransactorNickname', label: '客户公司办理人', minWidth: 200 },
        { prop: 'status', label: '合同状态', minWidth: 100, formatter: this.statusFormat },
        { prop: 'signingTime', label: '签订时间', minWidth: 140, formatter: this.timeFormat },
      ],
      tableData: [],
      cycleList: [
        { label: "无", value: 0 },
        { label: "周(1/4月)", value: 1 },
        { label: "月(1月)", value: 2 },
        { label: "季度(3月)", value: 3 },
        { label: "半年(6月)", value: 4 },
        { label: "年(12月)", value: 5 }
      ],
      status: [
        { label: "全部状态", value: -1 },
        { label: "生效中", value: 1 },
        { label: "正常终止", value: 2 },
        { label: "协商终止", value: 3 }
      ],
      taskList: [
        { label: "站点改造", value: 1 },
        { label: "抢修", value: 2 },
        { label: "试验", value: 3 },
        { label: "巡检", value: 4 },
        { label: "其他", value: 5 }
      ],
      contractIdList: []
    }
  },
  created () {
    this.$api.contract.getListAllCompany().then((res) => {
      if (res.success) {
        this.allCompany = res.data
      }
    })
    this.$api.contract.getListClientsForElectricOperationsCompany(0, null, null).then((res) => {
      if (res.success) {
        this.clientCompany = res.data
      }
    })
    this.handleQuery()
  },
  methods: {
    timeFormat (row, column, cellValue, index) {
      return this.$moment(cellValue).format('YYYY/MM/DD')
    },
    statusFormat (row, column, cellValue, index) {
      return this.status.find(c => c.value == cellValue)["label"]
    },
    handleQuery () {
      const companyid = this.filters.companyid === '' ? null : [this.filters.companyid]
      console.log(companyid, this.filters.companyid)
      const startTime = this.filters.time.length > 0 ? this.filters.time[0] : ''
      const endTime = this.filters.time.length > 0 ? this.filters.time[1] : ''
      this.$api.contract.getListElectricOperationsContractForServiceProvider(
        0,
        companyid,
        startTime,
        endTime,
        this.filters.status
      ).then((res) => {
        if (res.success) {
          this.tableData = res.data
          if (this.projectIsNeed) {
            this.handleProjectQuery()
          }
        }
      })
    },
    handleProjectQuery () {
      this.contractIdList = this.tableData.map((item) => {
        return item.id
      })
      this.$api.contract.getContractProjectByContractId({
        companyId: 0,
        contactId: this.contractIdList
      }).then((res) => {
        if (res.success) {
          // res.data.forEach((item) => {
          //   this.tableData = this.tableData.map((contract) => {
          //     return {
          //       ...contract,
          //       children: contract.id === 
          //     }
          //   })
          // })
        }
      })
    },
    handleDetail (params) {
      this.detailDrawerVisible = true
      this.$nextTick(() => {
        this.$refs.detailDrawer.init(params.row)
      })
    },
    handleAdd () {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(null)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
  background-color: #fff;
  overflow: auto;
  text-align: left;
  color: #333;
}

</style>